import { HistoryNavButtons } from '@/desktop/HistoryNavButtons';
import { shellLeavesNavigationToWeb } from './shellDetection';

/**
 * I-1304 (IL-17): whether this window draws the iPad app's Back and Forward — in a shell that leaves
 * the navigation to the web, in the desktop layout. The phone layout has its back row (IU-3), a
 * browser its own buttons, and the Mac app its title bar.
 */
export function drawsShellHistoryNav(phoneLayout: boolean): boolean {
  return !phoneLayout && shellLeavesNavigationToWeb();
}

/**
 * The Mac app's Back and Forward (`HistoryNavButtons`), sized for a finger (`h-touch` boxes), the glyph
 * the ghost buttons beside them draw (the narrow header's sidebar button).
 */
export function ShellHistoryNav() {
  return (
    <HistoryNavButtons
      className="flex shrink-0 items-center gap-2"
      buttonClassName="grid h-touch w-touch place-items-center rounded-full text-gray-600 transition-colors duration-150 focus:outline-none focus-visible:ring-2 focus-visible:ring-focus enabled:hover:bg-gray-100 enabled:hover:text-gray-900 enabled:active:bg-gray-200 disabled:cursor-default disabled:opacity-30 dark:text-gray-300 dark:enabled:hover:bg-gray-800 dark:enabled:hover:text-white dark:enabled:active:bg-gray-700"
      iconClassName="h-5 w-5 touch-glyph"
    />
  );
}
